import React from 'react'
import { Loading, Heading } from '@myxplor/ui'

import LocalAsyncStore from '../../../local-async-store'

import List from './list'
import GovRegistrationSyncButton from './sync-button'
import './styles/ccms-registrations.css'

export const apiEndPoint = ({ record }) =>
  `/api/${record.type}s/${record.type_id}/gov-registrations`

export const CCMSRegistrations = ({
  ccms_registrations = [],
  record,
  refresh_ccms_registrations,
}) =>
  ccms_registrations.loading ? (
    <Loading>Loading CCMS Registrations</Loading>
  ) : ccms_registrations.data.length === 0 ? (
    <Heading small compact>
      No CCMS Registrations found
    </Heading>
  ) : (
    <List
      records={ccms_registrations.data}
      topContent={
        <div className="ccmsRegistrations--sync-buttons">
          <GovRegistrationSyncButton
            id={record.id}
            onComplete={() => refresh_ccms_registrations(apiEndPoint({ record }))}
            ccms_registrations={ccms_registrations.data}
          />
        </div>
      }
    />
  )

export default LocalAsyncStore('ccms_registrations', CCMSRegistrations, apiEndPoint)



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccms-registrations/index.jsx